import { Prettify } from '@givebacks/utils/types';
import { Button, Center, Container, Stack, Text, ThemeIcon } from 'ui';
import { IconLoadingError } from 'ui/Icons';

import { ErrorBoundaryCardProps, FallBackComponentProps } from './types';

type ErrorCardProps = Prettify<FallBackComponentProps> & ErrorBoundaryCardProps;

const ErrorContainer = ({
  title = 'Unable to load section',
  description = 'Please try again or reload section.',
  icon = true,
  withRetry = true,
  resetError,
}: ErrorCardProps) => {
  return (
    <Container fluid p="lg">
      <Stack gap={24}>
        <Center>
          {icon && (
            <ThemeIcon variant="transparent" size={128}>
              <IconLoadingError size={128} />
            </ThemeIcon>
          )}
        </Center>

        <Stack ta="center" gap={8}>
          <Text fz="20" fw="600" c="gray.6">
            {title}
          </Text>
          <Text c="gray.6" fz="12">
            {description}
          </Text>
        </Stack>

        {withRetry && (
          <Button onClick={resetError} fullWidth>
            Reload
          </Button>
        )}
      </Stack>
    </Container>
  );
};

export { ErrorContainer };
